import { useMemo } from "react";
import React from "react";

import CheckboxOffIcon from "@images/checkbox/checkbox-off.svg";
import CheckboxOnIcon from "@images/checkbox/checkbox-on.svg";
import CheckboxOffDisabledIcon from "@images/checkbox/checkbox-off-disable.svg";
import CheckboxOnDisabledIcon from "@images/checkbox/checkbox-on-disable.svg";

interface SntCheckBoxProps {
  checked?: boolean;
  label?: React.ReactNode;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  title?: string;
}

interface CheckboxStyle {
  style: React.CSSProperties;
  className: string;
}

const _normal: React.CSSProperties = {
  display: "inline-block",
  verticalAlign: "middle",
  margin: 0,
  padding: 0,
  width: "16px",
  height: "16px",
  background: `url(${CheckboxOffIcon}) no-repeat`,
  border: "none",
  cursor: "pointer",
};

const _checked: React.CSSProperties = {
  background: `url(${CheckboxOnIcon}) no-repeat`,
};

const _disabled: React.CSSProperties = {
  background: `url(${CheckboxOffDisabledIcon}) no-repeat`,
  cursor: "default",
};

const disabled_checked: React.CSSProperties = {
  background: `url(${CheckboxOnDisabledIcon}) no-repeat`,
  cursor: "default",
};

const SntCheckBox: React.FC<SntCheckBoxProps> = ({
  checked = false,
  label,
  disabled = false,
  onChange,
  title,
}) => {
  const _style = useMemo<CheckboxStyle>(() => {
    let rs: React.CSSProperties = Object.assign({}, _normal);
    let _clss = "";
    if (checked) {
      rs = Object.assign(rs, _checked);
      _clss += "snt_checked";
    }
    if (disabled) {
      _clss += " snt_checkbox_disable";
      if (checked) {
        rs = Object.assign(rs, disabled_checked);
      } else {
        rs = Object.assign(rs, _disabled);
      }
    }

    return {
      style: rs,
      className: _clss,
    };
  }, [checked, disabled]);

  function onClick() {
    if (!disabled) {
      onChange?.(!checked);
    }
  }

  return (
    <div className="d-inline-block">
      <div
        className={`${_style.className} me-2`}
        style={_style.style}
        onClick={onClick}
        title={title}
      ></div>
      <span className="align-middle">{label || ""}</span>
    </div>
  );
};

export default SntCheckBox;
